import "@/App.css";
import { Toaster } from "sonner";
import { useTheme } from "@/lib/theme";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import QuemSomos from "@/components/site/QuemSomos";
import Servicos from "@/components/site/Servicos";
import Cases from "@/components/site/Cases";
import TrabalheConosco from "@/components/site/TrabalheConosco";
import Contato from "@/components/site/Contato";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

function App() {
    const { theme, toggle } = useTheme();
    return (
        <div className="App noise relative bg-background text-foreground transition-colors">
            <Header theme={theme} toggleTheme={toggle} />
            <main className="relative z-[2]">
                <Hero />
                <QuemSomos />
                <Servicos />
                <Cases />
                <TrabalheConosco />
                <Contato />
            </main>
            <Footer />
            <WhatsAppButton />
            <Toaster
                theme={theme}
                position="top-right"
                toastOptions={{
                    className: "border",
                }}
            />
        </div>
    );
}

export default App;
